import Table from '@/common/components/Table';
import React from 'react';
import { HEADERS } from './constants/headers';
import { getRaws } from './helpers/getRaws';
import { useNavigate } from 'react-router-dom';

const NotPickUpTable = ({ data }) => {
	const navigate = useNavigate();

	return (
		<Table
			className='styled-table'
			headers={HEADERS}
			raws={getRaws(data, navigate)}
		/>
	);
};

export default NotPickUpTable;
